export default "__VITE_ASSET__fec99690__"